import React from 'react'
import styles from './header.jcss'
import Icon from '../../../blocks.simple/icon/icon'
import { colors } from '../../../theme'
import EditText from '../../../blocks.simple/editText/editText'
import translate from '../../../core/translate'
import Button from '../../../blocks.simple/button/button'
import helpers from '../../../core/helpers'
import { cn } from 'ethcss'
import item from '../../../blocks.simple/item/item.jcss'
import { Tooltip } from '../../../atoms/Tooltip'

interface IHeader {
    selectedItemsLength: number
    deleteAllSelected: (value: boolean) => void
    onAdd: () => void
}

export const Header = ({ selectedItemsLength, deleteAllSelected, onAdd }: IHeader) => {
    return (
        <div className={styles.header}>
            <div className={styles.controlPositionBlock}>
                <div className={styles.controlBlock}>
                    {helpers.isAvailableAction(null, {
                        key: 'DSNotifications',
                        action: 'create',
                    }) && (
                        <Icon
                            type={'plus'}
                            color={colors.blueAccent}
                            size={18}
                            className={styles.addIcon}
                            onClick={onAdd}
                        />
                    )}
                    {helpers.isAvailableAction(null, {
                        key: 'DSNotifications',
                        action: 'delete',
                    }) && (
                        <Icon
                            type={'delete'}
                            color={colors.blueAccent}
                            disabled={!selectedItemsLength}
                            size={18}
                            onClick={() => deleteAllSelected(true)}
                        />
                    )}
                </div>
            </div>
            <div className={styles.legend}>
                <Tooltip isEnabled={true} title={translate('notificationInProgress')} position="left">
                    <div className={styles.active}></div>
                </Tooltip>
                <Tooltip isEnabled={true} title={translate('errorOccurred')} position="left">
                    <div className={styles.error}></div>
                </Tooltip>
            </div>
        </div>
    )
}
